import { useState } from "react";
import { CalendarClock } from "lucide-react";
import { Button } from "@/components/ui/button";
import { ScheduleConditionEditDialog } from "./ScheduleConditionEditDialog";
import { coerceScheduleValue, formatScheduleSummary, type ScheduleConditionValue } from "@/lib/schedule";

interface ScheduleConditionSummaryProps {
  value: unknown;
  onChange: (value: ScheduleConditionValue) => void;
}

export function ScheduleConditionSummary({ value, onChange }: ScheduleConditionSummaryProps) {
  const [isEditDialogOpen, setIsEditDialogOpen] = useState(false);

  // Persisted values arrive as `any` off JSONB; coerce before reading them.
  const coerced = coerceScheduleValue(value);
  const hasWindows = coerced.windows.length > 0;

  return (
    <>
      <div className="flex items-center justify-between gap-3 p-3 bg-muted/50 rounded-md">
        <span className={hasWindows ? "text-sm text-foreground" : "text-sm text-muted-foreground"}>
          {hasWindows ? `Active ${formatScheduleSummary(coerced)}` : "No schedule set"}
        </span>
        <Button
          type="button"
          variant="outline"
          size="sm"
          onClick={() => setIsEditDialogOpen(true)}
          className="shrink-0"
        >
          <CalendarClock className="h-4 w-4 mr-1.5" />
          {hasWindows ? "Edit schedule" : "Set schedule"}
        </Button>
      </div>

      <ScheduleConditionEditDialog
        isOpen={isEditDialogOpen}
        onClose={() => setIsEditDialogOpen(false)}
        value={value}
        onChange={onChange}
      />
    </>
  );
}
